"use client"
import { deletePhase, deleteYear } from "@/actions";
import { renderUiStore } from "@/store/renderclient/renderClient-store";
import { Tooltip } from "@mui/material";
import { useRouter } from "next/navigation";
import { RiDeleteBinLine } from "react-icons/ri";
import Swal from "sweetalert2";

interface Props {
    id: number,
    funtion: (id: number) => Promise<void>,
    optionalFuntion?: any,
    disabled?: boolean,
    tooltip?: string
}

export const DeleteFuntions = ({ id, funtion, optionalFuntion, disabled, tooltip }: Props) => {
    const router = useRouter()

    const render = renderUiStore(state => state.renderStore)
    const handleDelete = (id: number) => {
        Swal.fire({
            title: "¿Estas seguro de Eliminar?",
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si"
        }).then((result) => {
            if (result.isConfirmed) {
                funtion(id).then((res: any) => {

                    if(optionalFuntion){
                        optionalFuntion()
                    } 

                    if (!res.message || res.message === "successful deletion" || res?.message?.includes("Agendamiento") || res?.message?.includes("Informe")) {
                        //router.refresh()
                        render()
                        Swal.fire({
                            title: "Borrado",
                            text: "Se borro correctamente",
                            icon: "success"
                        });
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: `${res.message}`,
                            icon: "error"
                        });
                    }
                })
            }
        });
    }

    return (
        <Tooltip title={tooltip ?? "Eliminar"} arrow>
            <span>
                <button type="button" onClick={() => handleDelete(id)} disabled={disabled} className={`bg-red-500 text-white rounded-lg p-2 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}><RiDeleteBinLine size={18} /></button>
            </span>
        </Tooltip>

    )
}
